<template>
  <!-- CREATE -->
  <v-dialog v-model="isDialogOpenCreate" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Tambah</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="formCreate" v-model="isFormValidCreate">
          <v-text-field
            v-model="name"
            label="Nama"
            :rules="[(v) => !!v || 'Name wajib']"
          />

          <v-text-field v-model="code_uom" label="Code uom" />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="secondary" @click="isDialogOpenCreate = false">
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          :disabled="!isFormValidCreate"
          @click="submitCreate"
        >
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/utils/api";
import store from "@/store";

export default {
  name: "DialogUom",

  data() {
    return {
      // FORM
      id: null,
      name: null,
      code_uom: null,

      // UI
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      isLoadingSubmit: false,

      // VALIDATION
      rules: {
        required: [(v) => !!v || "Field wajib diisi"],

        requiredNumber: [
          (v) =>
            v !== null && v !== "" && v !== undefined
              ? true
              : "Field wajib diisi",
        ],
      },
    };
  },

  methods: {
    // =========================
    // OPEN DIALOG
    // =========================
    openDialogCreate(payload = {}) {
      this.resetForm();
      this.id = payload.id || null;
      this.name = payload.searchUom;
      this.code_uom = payload.searchUom;
      this.isDialogOpenCreate = true;
    },

    // =========================
    // RESET FORM
    // =========================
    resetForm() {
      this.id = null;
      this.name = null;
      this.code_uom = null;
      this.isFormValidCreate = false;

      this.$nextTick(() => {
        if (this.$refs.formCreate) {
          this.$refs.formCreate.resetValidation();
        }
      });
    },

    // =========================
    // SUBMIT CREATE
    // =========================
    async submitCreate() {
      const isValid = this.$refs.formCreate.validate();

      if (!isValid) return;

      this.isLoadingSubmit = true;

      store.dispatch("showLoading");

      try {
        const payload = {
          code_uom: this.code_uom,
          name: this.name,
        };

        const response = await api.post("/uom", payload);

        const message = response.data.message || "Berhasil menambahkan data";

        // emit ke parent
        this.$emit("success", response.data);

        // close dialog
        this.isDialogOpenCreate = false;

        // reset form
        this.resetForm();

        // snackbar
        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: true,
        });
      } catch (error) {
        let message = "Gagal menambahkan data!";

        if (error.response) {
          message = error.response.data.message || message;
        } else {
          message = error.message || message;
        }

        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: false,
        });
      } finally {
        this.isLoadingSubmit = false;

        store.dispatch("hideLoading");
      }
    },
  },
};
</script>
